/**************************************************
 * Nombre:       Seccion_Educacion
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Home_Indicadores from "./Componentes/Home_Indicadores";
import Home_Documentos from "./Componentes/Home_Documentos";
import Home_Preguntas from "./Componentes/Home_Preguntas";
import Home_Testimonios from "./Componentes/Home_Testimonios";
import Educacion_Portada from "./Componentes/Educacion_Portada";
import Educacion_Cursos from "./Componentes/Educacion_Cursos";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";

const Seccion_Educacion = () => {
    const {sCell} = useResponsive()


    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Educacion_Portada/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-start', mt: -22}}>
                <Educacion_Cursos/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'flex-start', mt: 12}}>
                <Home_Indicadores/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: -12}}>
                <Home_Documentos/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 12}}>
                <Home_Preguntas/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 14, mb: 14}}>
                <Home_Testimonios/>
            </Grid>


        </Grid>
    )

}
export default Seccion_Educacion